<template>
  <div>
    <app-logo v-if="logoUrl" />
    <div v-else>{{ fallbackText }}</div>
  </div>
</template>

<script>
import { mapGetters } from "pinia"
import { useConfigurationStore } from "@/store/configuration.js"
import { useUserSessionStore } from "@/store/userSession.js"

export default {
  props: {
    text: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters(useConfigurationStore, ["configuration"]),
    ...mapGetters(useUserSessionStore, ["logoUrl"]),
    fallbackText() {
      return this.text || this.configuration.appTitle
    }
  }
}
</script>
